function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

document.addEventListener("DOMContentLoaded", function () {
  window.SLIDECART_OPENED = function () {
    $("#slidecarthq .upsell-add > button").click(function () {
      var title = $(this)
        .parent()
        .siblings()
        .closest(".upsell-text")
        .children("h3")
        .text();
      console.log(title);
      ga("send", "event", "upsell", "add", title);
    });
  };
});

function checkAge() {
  const gate = document.getElementById("age-gate-overlay");
  let age = getCookie("age");
  if (age != "true") {
    gate.style.display = "block";
  } else {
    gate.style.display = "none";
  }
}

function setAge(e) {
  console.log(e);
  setCookie("age", e, 360);
  checkAge();
}

checkAge();

document.addEventListener("DOMContentLoaded", function () {
  $("#sub-customize-collections").change(function () {
    window.location.href = $(this).val();
  });

  $("button.add-to-cart").on("click", function () {
    console.log("add to cart");
    window.uetq = window.uetq || [];
    window.uetq.push("event", "add_to_cart", {
      revenue_value: 1,
      currency: "USD",
    });
  });
});
